import { Version } from './Version'
import { FETCH_VERSION_SUCCESS } from './types'
import { versionReducer } from './reducer'
import { fetchVersionSuccessAction } from './actions'
import { fetchVersion } from './operations'

export {
  FETCH_VERSION_SUCCESS,
  versionReducer,
  fetchVersionSuccessAction,
  fetchVersion,
  Version
}
